import { queryOptions, useQuery, type UseQueryResult } from '@tanstack/react-query'

import { signalsKeys } from '@/features/signals/api/keys'
import { overlaysService } from '@/features/signals/api/overlaysService'
import type { ChartOverlays } from '@/schemas/signal-overlays'

/**
 * mm-be caches every signals read for five minutes and writes the levels once
 * a session, after the close (`jobs.compute_levels`), so asking sooner only
 * re-reads its cache. The same freshness `queries.ts` gives the other reads.
 */
const OVERLAYS_STALE_MS = 5 * 60_000

/**
 * Under `signalsKeys.all`, so the sweep that refreshes every signals read
 * takes this one too. Its own branch, as keys.ts's rule asks.
 */
export const chartOverlaysKey = (symbol: string, sessions: number) =>
  [...signalsKeys.all, 'chart-overlays', symbol, { sessions }] as const

export const chartOverlaysQueryOptions = (symbol: string, sessions: number) =>
  queryOptions({
    queryKey: chartOverlaysKey(symbol, sessions),
    queryFn: () => overlaysService.chartOverlays(symbol, sessions),
    staleTime: OVERLAYS_STALE_MS,
  })

export const useChartOverlays = (symbol: string, sessions: number): UseQueryResult<ChartOverlays> =>
  useQuery(chartOverlaysQueryOptions(symbol, sessions))
